import "./Category.scss";
import Products from "../Products/Products";


const Categorry = () => {
    return (
       <div className="category-main-content">
           <div className="layout">
              <div className="category-title">
                  Category Title
              </div>
            <Products />
           </div>
       </div>
    );
};


export default Categorry;